import { render, staticRenderFns } from "./proposal-user-info-content.vue?vue&type=template&id=accb0d22&scoped=true&"
import script from "./proposal-user-info-content.vue?vue&type=script&lang=js&"
export * from "./proposal-user-info-content.vue?vue&type=script&lang=js&"
import style0 from "./proposal-user-info-content.vue?vue&type=style&index=0&id=accb0d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accb0d22",
  null
  
)

/* custom blocks */
import block0 from "./proposal-user-info-content.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports